import { converterDataEua, converterDataHoraBr } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import { ISolicitacaoTerceiros } from "../interfaces/ISolicitacaoTerceiros";

export const COLUNAS_EXPORTACAO_SOLICITACOES_TERCEIROS = [
  "Solicitação",
  "PDI",
  "Empresa",
  "Processo",
  "Placa",
  "Renavam",
  "Chassi",
  "Marca/Modelo",
  "Proc. Detran",
];

export function linhasExportacaoSolicitacoesTerceiros(
  solicitacoes: ISolicitacaoTerceiros[]
) {
  return solicitacoes.map((solicitacao) => ({
    Solicitação: converterDataHoraBr(solicitacao.dataSolicitacao) ?? "",
    PDI: solicitacao.pdi ?? "",
    Empresa: solicitacao.empresa ?? "",
    Processo: solicitacao.idProcesso ?? "",
    Placa: solicitacao.placa,
    Renavam: solicitacao.renavam ?? "",
    Chassi: solicitacao.chassi ?? "",
    "Marca/Modelo": solicitacao.marcaModelo ?? "",
    "Proc. Detran": solicitacao.processoDetran ?? "",
  }));
}

export function exportarSolicitacoesTerceirosXlsx(
  solicitacoes: ISolicitacaoTerceiros[],
  hoje: Date = new Date()
) {
  const planilha = utils.json_to_sheet(
    linhasExportacaoSolicitacoesTerceiros(solicitacoes),
    { header: [...COLUNAS_EXPORTACAO_SOLICITACOES_TERCEIROS] }
  );
  const arquivo = utils.book_new();

  utils.book_append_sheet(arquivo, planilha, "Solicitações");
  writeFileXLSX(
    arquivo,
    `placas_terceiros_solicitacoes_${converterDataEua(hoje)}.xlsx`
  );
}
